import { PM_PROVIDERS } from 'common/constants/constants';
import { SPACES } from 'common/constants/sizes';
import { WhiteSection } from 'components/base/layout-components';
import React from 'react';
import { getSensorAuthorization } from '../../services/project-management.service';
import PMConfiguration from '../../connected-components/PMConfiguration';
import ConnectView from './components/ConnectView';
import { useSelector } from 'react-redux';
import { getSensorAuthorizations } from 'state/selectors/sensors-authorizations';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

const AzureBoards = ({ selectedTeam, isOrgSettings, entityName }) => {
  const sensorAuthorizations = useSelector(getSensorAuthorizations);
  const selectedManagementTool = getSensorAuthorization({
    sensorAuthorizations,
    sensorId: PM_PROVIDERS.AZURE_BOARDS
  });
  const isPmToolOk = selectedManagementTool?.state === 'ok';

  return (
    <WhiteSection t={SPACES['x-medium']}>
      {isPmToolOk ? (
        <PMConfiguration
          selectedTeam={selectedTeam}
          isOrgSettings={isOrgSettings}
          selectedManagementTool={selectedManagementTool}
          entityName={entityName}
        />
      ) : (
        <ConnectView />
      )}
    </WhiteSection>
  );
};

export default withErrorBoundary(AzureBoards, 'Azure Boards');
